import ViewModelBase from './ViewModelBase';
import enableAcceptBindings from '../mvvm/enableAcceptBindings';
import exposeBinding from '../mvvm/exposeBinding';
import UnitViewModel from './UnitViewModel';
import GenericModelViewModel from './GenericModelViewModel';
import CompositeProgressSource from '../progress/CompositeProgressSource';
import ParameterErrors from '../errors/ParameterErrors';
const { throwNotProvided } = ParameterErrors;
export default class SitePlan3DViewModel extends ViewModelBase{
	constructor(props){
		super(props);
		const {siteJson, configuration}=props;
		if(!configuration)throwNotProvided('configuration');
		this._configuration = configuration;
		this._loadingProgressProportionChanged= this._loadingProgressProportionChanged.bind(this);
		this._unitViewModels = siteJson.units.getArray().map(unit=>new UnitViewModel({siteJsonUnit:unit}));
		this._siteJson = siteJson;
		this._progressSourceLoading = new CompositeProgressSource();
		this._progressSourceLoading.addEventListener('progresschanged', this._loadingProgressProportionChanged);
		enableAcceptBindings(this);
		exposeBinding(this, 'zoom', ()=>this.zoom, (value)=>this.zoom = value);
		exposeBinding(this, 'loadProgressProportion', ()=>this.loadProgressProportion, (value)=>this.loadProgressProportion = value);
		exposeBinding(this, 'progressBarVisible', ()=>this.progressBarVisible);
	}
	get siteModels(){
		return this._siteJson.models.getModelsByGroupCode('site');
	}
	get configuration(){
		return this._configuration;
	}
	get progressSourceLoading(){
		return this._progressSourceLoading;
	}
	get units(){
		return this._unitViewModels;
	}
	get zoom(){
		return this._zoom;
	}
	set zoom(value){
		this._zoom = value;
	}
	get loadProgressProportion(){
		return this._progressSourceLoading.progressProportion;
	}
	get progressBarVisible(){
		return this._progressSourceLoading.progressProportion<1;
	}
	_loadingProgressProportionChanged(e){
		this.bindingsHandler.changed('loadProgressProportion', e.progressProportion);
		this.bindingsHandler.changed('progressBarVisible', e.progressProportion<1);
	}
}